/*
 * @Author: bbqin
 * @Date: 2022-10-14 16:28:59
 * @LastEditTime: 2023-10-13 10:25:27
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\TransferTable\ellipsisToTooltip.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip as NCTooltip } from '@platform/base'
export default class EllipsisToTooltip extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible || false
        };
    }

    componentWillReceiveProps() {
        let selfDom = ReactDOM.findDOMNode(this);
        let wrapperDom = selfDom && (selfDom.parentNode || selfDom.parentElement || selfDom);
        if ((wrapperDom && wrapperDom.clientWidth < wrapperDom.scrollWidth) || this.props.noEllipsis) {
            this.setState({
                visible: true
            });
        } else {
            this.setState({
                visible: false
            });
        }
    }

    render() {
        let { children, className, ...other } = this.props;

        return (
            this.state.visible ? (
                <NCTooltip
                    {...other}
                    placement="left"
                    delay={1}
                >
                    <span className={`${(this.state.visible ? className : '') || ''}`}>{children}</span>
                </NCTooltip>
            ) : children);
    }
}